/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Dev, 1 = ReleaseCandidate, 2 = Release
 */
export enum FirmwareChannel {
    Dev = 0,
    ReleaseCandidate = 1,
    Release = 2
}

